import React, { useRef, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import StyledInput from '../common/StyledInput';
import { PrimaryButton } from '../common/Buttons';
import Recaptcha from '../common/Recaptcha';
import './style.css';

export default function Form() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });
  const [recaptchaVerified, setRecaptchaVerified] = useState(false);
  const recaptchaRef = useRef();

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleRecaptcha = (token) => setRecaptchaVerified(!!token);
  const handleRecaptchaExpired = () => setRecaptchaVerified(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!recaptchaVerified) {
      alert('Please complete the reCAPTCHA.');
      return;
    }
    // Your form submission logic here
    alert('Form submitted!');
    setForm({ name: '', phone: '', email: '', message: '' });
    setRecaptchaVerified(false);
    recaptchaRef.current?.reset();
  };

  return (
    <section id="contact" className="py-5">
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md="8" lg="6">
            <form className="contact-form mx-auto" onSubmit={handleSubmit} autoComplete="off">
              <Row>
                <Col xs="12" className="mb-4">
                  <StyledInput
                    label="Name"
                    id="contact-name"
                    name="name"
                    type="text"
                    value={form.name}
                    onChange={handleChange('name')}
                    required
                  />
                </Col>
                <Col xs="12" className="mb-4">
                  <StyledInput
                    label="Phone"
                    id="contact-phone"
                    name="phone"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange('phone')}
                    required
                  />
                </Col>
                <Col xs="12" className="mb-4">
                  <StyledInput
                    label="E-Mail"
                    id="contact-email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange('email')}
                    required
                  />
                </Col>
              </Row>
              <div className="mb-4">
                <StyledInput
                  label="How can we help you?"
                  id="contact-message"
                  name="message"
                  type="textarea"
                  value={form.message}
                  onChange={handleChange('message')}
                  rows={4}
                  required
                />
              </div>
              <div className="text-center mb-4">
                <Recaptcha
                  ref={recaptchaRef}
                  onVerify={handleRecaptcha}
                  onExpire={handleRecaptchaExpired}
                />
              </div>
              <div className="text-center my-4">
                <PrimaryButton
                  type="submit"
                  disabled={!recaptchaVerified}
                >
                  Send
                </PrimaryButton>
                <p className="small mt-3">
                  We will contact you within 1-2 business days.
                </p>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
